export default __webpack_public_path__ + "img/154463c4f69ad9e00d1624bc074d96d0.svg";